import { CsvError } from './CsvError.js';
import { is_object } from '../utils/is_object.js';
var normalize_columns_array = function normalize_columns_array(columns) {
  var normalizedColumns = [];
  for (var i = 0, l = columns.length; i < l; i++) {
    var column = columns[i];
    if (column === undefined || column === null || column === false) {
      normalizedColumns[i] = {
        disabled: true
      };
    } else if (typeof column === 'string') {
      normalizedColumns[i] = {
        name: column
      };
    } else if (is_object(column)) {
      if (typeof column.name !== 'string') {
        throw new CsvError('CSV_OPTION_COLUMNS_MISSING_NAME', ['Option columns missing name:', "property \"name\" is required at position ".concat(i), 'when column is an object literal']);
      }
      normalizedColumns[i] = column;
    } else {
      throw new CsvError('CSV_INVALID_COLUMN_DEFINITION', ['Invalid column definition:', 'expect a string or a literal object,', "got ".concat(JSON.stringify(column), " at position ").concat(i)]);
    }
  }
  return normalizedColumns;
};
export { normalize_columns_array };